import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/trend-up-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M22.9999 14C22.9999 14.5523 22.5522 15 21.9999 15C21.4476 15 20.9999 14.5523 20.9999 14V9.41406L14.8388 15.5762C14.6525 15.7625 14.4705 15.9451 14.3046 16.0859C14.1298 16.2344 13.9078 16.3941 13.6181 16.4883C13.2164 16.6188 12.7834 16.6188 12.3818 16.4883C12.092 16.3941 11.8701 16.2344 11.6952 16.0859C11.5293 15.9451 11.3474 15.7625 11.1611 15.5762L8.42375 12.8389C8.21409 12.6292 8.09886 12.5142 8.00969 12.4385C8.00634 12.4356 8.00296 12.4332 7.99992 12.4307C7.99689 12.4332 7.99351 12.4356 7.99016 12.4385C7.90099 12.5142 7.78576 12.6292 7.5761 12.8389L2.70696 17.707C2.31643 18.0976 1.68342 18.0976 1.29289 17.707C0.902369 17.3165 0.902369 16.6835 1.29289 16.293L6.16106 11.4238C6.34738 11.2375 6.52934 11.0549 6.69524 10.9141C6.87008 10.7656 7.09205 10.6059 7.38176 10.5117C7.73319 10.3975 8.10837 10.3841 8.46574 10.4697L8.61809 10.5117L8.82317 10.5938C9.01588 10.6853 9.17353 10.8028 9.30461 10.9141C9.47051 11.0549 9.65247 11.2375 9.83879 11.4238L12.5761 14.1611C12.7858 14.3708 12.901 14.4858 12.9902 14.5615C12.9933 14.5642 12.997 14.566 12.9999 14.5684C13.0028 14.566 13.0065 14.5642 13.0097 14.5615C13.0989 14.4858 13.2141 14.3708 13.4238 14.1611L19.5859 8H14.9999C14.4476 8 13.9999 7.55228 13.9999 7C13.9999 6.44772 14.4476 6 14.9999 6H21.9999C22.5522 6 22.9999 6.44772 22.9999 7V14Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as TrendUp01Icon };
